import { Controller } from "@hotwired/stimulus"
import { Chart, BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js"

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend)

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    labels: Array,
    counts: Array,
    label: { type: String, default: "下载次数" }
  }

  connect() {
    if (this.labelsValue.length === 0) return

    this.chart = new Chart(this.canvasTarget, {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: [{
          label: this.labelValue,
          data: this.countsValue,
          backgroundColor: "rgba(59, 130, 246, 0.7)",
          borderColor: "rgba(59, 130, 246, 1)",
          borderWidth: 1,
          borderRadius: 4,
          maxBarThickness: 48
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            callbacks: {
              label: (ctx) => `${ctx.parsed.y} 次`
            }
          }
        },
        scales: {
          x: {
            ticks: {
              maxRotation: 45,
              minRotation: 0,
              font: { size: 11 },
              callback: function(value) {
                const label = this.getLabelForValue(value)
                return label.length > 10 ? label.slice(0, 10) + "…" : label
              }
            },
            grid: { display: false }
          },
          y: {
            beginAtZero: true,
            ticks: {
              precision: 0,
              font: { size: 11 }
            }
          }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
